// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Salvta_container__Wa4lK {
  animation: Salvta_init__JmnD3 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/*--Header--*/
.Salvta_container__Wa4lK .Salvta_header__6DjsU {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Salvta_container__Wa4lK .Salvta_header__6DjsU .Salvta_titleContainer__JYwlz {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Salvta_container__Wa4lK .Salvta_header__6DjsU .Salvta_titleContainer__JYwlz h4 {
  text-align: left;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.Salvta_container__Wa4lK .Salvta_header__6DjsU .Salvta_uploadBtn__8NN-3 {
  width: 80%;
  margin-bottom: 10px;
}

.Salvta_container__Wa4lK .Salvta_noResults__0Tyr9 {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 2rem;
  font-weight: 300;
  height: 300px;
}

.Salvta_container__Wa4lK .Salvta_header__6DjsU .Salvta_filters__4aE\\+w {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Salvta_container__Wa4lK .Salvta_header__6DjsU .Salvta_filters__4aE\\+w .Salvta_filterButton__KO0nf {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-bottom: 10px;
  border-radius: 5px;
}

.Salvta_container__Wa4lK .Salvta_header__6DjsU .Salvta_filters__4aE\\+w .Salvta_filterButton__KO0nf p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.Salvta_container__Wa4lK .Salvta_data__ceKhU .Salvta_tableContainer__KBaPD {
  animation: Salvta_init2__BXNZq 0.5s;
  border-radius: 5px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Salvta_container__Wa4lK .Salvta_data__ceKhU .Salvta_tableContainer__KBaPD .Salvta_iconbtn__5K\\+yF {
  transition: 0.3s;
  font-size: 2rem;
}

.Salvta_container__Wa4lK .Salvta_data__ceKhU .Salvta_tableContainer__KBaPD .Salvta_iconbtn__5K\\+yF:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.Salvta_container__Wa4lK .Salvta_data__ceKhU .Salvta_pagination__fDTv6 {
  margin-top: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.Salvta_container__Wa4lK .Salvta_loader__9hZdM {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

@media screen and (max-width: 500px) {
  .Salvta_container__Wa4lK .Salvta_header__6DjsU .Salvta_titleContainer__JYwlz h4 {
    font-size: 1.5rem;
  }
}

@keyframes Salvta_init__JmnD3 {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes Salvta_init2__BXNZq {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/ArchivosSalvta/Salvta.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mCAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: left;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .uploadBtn {\n  width: 80%;\n  margin-bottom: 10px;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: init2 0.5s;\n  border-radius: 5px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 2rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .data .pagination {\n  margin-top: 50px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n\n@keyframes init {\n  0% {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(-10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Salvta_container__Wa4lK`,
	"init": `Salvta_init__JmnD3`,
	"header": `Salvta_header__6DjsU`,
	"titleContainer": `Salvta_titleContainer__JYwlz`,
	"uploadBtn": `Salvta_uploadBtn__8NN-3`,
	"noResults": `Salvta_noResults__0Tyr9`,
	"filters": `Salvta_filters__4aE+w`,
	"filterButton": `Salvta_filterButton__KO0nf`,
	"data": `Salvta_data__ceKhU`,
	"tableContainer": `Salvta_tableContainer__KBaPD`,
	"init2": `Salvta_init2__BXNZq`,
	"iconbtn": `Salvta_iconbtn__5K+yF`,
	"pagination": `Salvta_pagination__fDTv6`,
	"loader": `Salvta_loader__9hZdM`
};
export default ___CSS_LOADER_EXPORT___;
